import { makeAutoObservable } from 'mobx'
import { type RootStore } from 'stores/RootStore'

export class ConfettiStore {
  rootStore: RootStore

  private _shown: boolean = false

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  get shown() {
    return this._shown
  }

  show() {
    this._shown = true
  }

  hide() {
    this._shown = false
  }
}
